import { navigate } from 'svelte-routing'
import { get } from 'svelte/store'
import store from '~/Library/store'

const AUTHENTICATE = `mutation signin($identity: String, $secret: String) {
  authenticate: authenticateUserWithPassword(email: $identity, password: $secret) {
    item {
      id,
      name,
      isAdmin,
      email
    }
  }
}`

const GET_ALL_FOR_YOU = `query {
  allForYous {
    id,
    title,
    description,
    image {
      publicUrlTransformed(transformation: {})
    },
    offerLink,
    offerCode
  }
}`
const GET_ALL_FOR_YOUR_CAREER = `query {
  allForYouCareers {
    id,
    title,
    description,
    image {
      publicUrlTransformed(transformation: {})
    },
    offerLink,
    offerCode
  }
}`
const GET_ALL_MENTORS = `query {
  allMentors {
    id,
    title,
    short_description,
    long_description,
    quote,
    jobTitle,
    linkedinProfile,
    bookingLink,
    image {
      publicUrlTransformed(transformation: { effect: "grayscale"})
    },
    specialities1,
    specialities2,
    specialities3,
    specialities4,
    availability,

  }
}`
const CREATE_EMAIL_SUBMISSION = `mutation createEmailSubmission($sender: String, $subject: String, $message: String) {
  createEmailSubmission(data: {
    sender: $sender,
    subject: $subject, 
    message: $message
  }){
    subject
  }
}`

const CREATE_PASSWORD_RESET = `mutation createForgotPassword($email: String) {
  createForgotPassword(data: {
    email: $email, 
    newPassword: "forgot"
  }){
    email
  }
}`

const apiCall = ({ query, variables }) => new Promise(async (resolve, reject) => {
  try {
    const data = { query }
    if (variables) data.variables = variables

    const API_BASE_URL = process.env.API_URL
    const rsp = await fetch(API_BASE_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Credentials': true,
      },
      body: JSON.stringify(data),
      credentials: 'include',
    })

    const body = await rsp.json()

    if (typeof body.errors !== 'undefined') {
      if (body.errors.find((e) => e.name === 'AccessDeniedError')) {
        store.reset()
        setTimeout(() => navigate('/login'))
      }
      reject(body.errors)
    }
    resolve(body)
  } catch (err) {
    reject(err)
  }
})

export const loginUser = async (variables) => apiCall({ query: AUTHENTICATE, variables })
export const getCards = async (key) => {
  const queries = {
    personal: GET_ALL_FOR_YOU,
    career: GET_ALL_FOR_YOUR_CAREER,
    mentors: GET_ALL_MENTORS,
  }
  return apiCall({ query: queries[key] })
}
export const submitContactForm = async (variables) => apiCall({ query: CREATE_EMAIL_SUBMISSION, variables })
export const createPasswordReset = async (variables) => apiCall({ query: CREATE_PASSWORD_RESET, variables })

export const createOfferSignup = async (d) => {
  const query = `mutation {
    createOfferSignup(data: ${d}){
      title
    }
  }`
  return apiCall({ query })
}
